<template>
  <div v-if="cdata.length" class="left-top">
    <v-chart :forceFit="true" :height="height" :data="cdata" :padding="padding">
      <v-coord type="rect" direction="LT" />
      <v-tooltip />
      <v-legend />
      <v-axis dataKey="time" position="right" :label="label2" />
      <v-axis dataKey="name" :label="label" />
      <v-interval position="name*time" :label="labelInterval" :opcaity="1"></v-interval>
      <!-- <v-bar position="name*time" /> -->
    </v-chart>
  </div>
</template>

<script>
const DataSet = require('@antv/data-set')

export default {
  props: {
    cData: {
      default() {
        return []
      },
    },
  },
  mounted() {
    const data = this.cData.sort((a, b) => {
      return a.time - b.time > 0
    })

    const dv = new DataSet.View().source(data)
    dv.transform({
      type: 'sort',
      callback(a, b) {
        return a.time - b.time > 0
      },
    })
    const cdata = dv.rows

    const scale = [
      {
        dataKey: 'time',
        tickInterval: 20,
        alias: '时长(分钟)',
      },
    ]

    const label = {
      offset: 12,
      textStyle: {
        fill: '#82A9EF',
      },
    }
    const label2 = {
      textStyle: {
        fill: '#82A9EF',
      },
    }

    const labelInterval = [
      'time',
      // {
      //   useHtml: true,
      //   htmlTemplate: function htmlTemplate(text, item) {
      //     var a = item.point
      //     return '<span class="g2-label-item"><p class="g2-label-item-value">' + a.sport_time + '</p></div>'
      //   },
      // },
    ]

    this.scale = scale
    this.label = label
    this.label2 = label2
    this.cdata = cdata
    this.labelInterval = labelInterval

    this.setStyle()
  },
  data() {
    return {
      labelInterval: [],
      scale: [],
      cdata: [],
      height: 360 * (window.innerWidth / 1920),
      label: [],
      label2: [],
      adjust: [],
      padding: [
        0 * (window.innerWidth / 1920),
        20 * (window.innerWidth / 1920),
        120 * (window.innerWidth / 1920),
        100 * (window.innerWidth / 1920),
      ],
    }
  },
  methods: {
    setStyle() {
      const id = 'legend-html'
      if (document.getElementById(id)) {
        return
      }
      const styleTxt = `
          .g2-label-item {
              font-size: 12px;
              text-align: center;
              line-height: 1.5;
          }

          .g2-label-item-value {
              color: #fff;
          }

          .g2-label-item-percent {
              color: #fff;
          }
        `
      const style = document.createElement('style')
      style.setAttribute('id', id)
      style.innerHTML = styleTxt
      document.getElementsByTagName('head')[0].appendChild(style)
    },
  },
}
</script>

<style lang="less" scoped>
.left-top {
  padding: 0 15px;
  margin-top: 36px;
}
</style>
